<template>
    <div>
        <v-container fluid class="pb-0 d-flex">
            <v-row dense class="px-2">
                <v-col cols="12" md="1" class="pa-0">
                    <div class="d-flex align-center mt-1">
                        <slot name="breadcrumbs" />
                    </div>
                </v-col>
                <v-col cols="12" md="11" class="pa-0">
                    <div class="mt-1">
                        <v-row>
                            <v-col cols="auto" md="3" class="pb-0">
                                <bee-account-autocomplete
                                    v-model="accountId"
                                    context="invoice"
                                    :action-name="actions.CREATE"
                                    :hide-details="false" 
                                    :label="$t('InvoiceBuyPage.account')"
                                    color="primary"
                                    :items="configs.accounts.filter(c=>c.type == 2)"
                                    :with-balance="true"
                                    :disabled="loading"
                                ></bee-account-autocomplete>
                            </v-col>
            
                            <!-- from-date -->
                            <v-col lg="2" md="3" sm="4" cols="6">
                                <bee-date-input
                                    v-model="fromDate"
                                    :label="$t('inputs.from-date')"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-calendar"
                                    user-menu-picker
                                    input-format-order="DD-MM-YYYY"
                                    :disabled="loading"
                                ></bee-date-input>
                            </v-col>
                            
                            <!-- to-date -->
                            <v-col lg="2" md="3" sm="4" cols="6">
                                <bee-date-input
                                    v-model="toDate"
                                    :label="$t('inputs.to-date')"
                                    dense
                                    hide-details
                                    prepend-icon="mdi-calendar"
                                    user-menu-picker
                                    input-format-order="DD-MM-YYYY"
                                    :disabled="loading"
                                ></bee-date-input>
                            </v-col>
                            <v-col lg="2" md="3" sm="4" cols="6">
                                <v-text-field 
                                    v-model="keywords"
                                    :label="$t('AccountStatementPage.search-within-caption')"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-btn
                                    @click="getStatement()"
                                    dark
                                    color="blueGray"
                                    type="submit"
                                    :loading="loading"
                                >
                                    {{$t('search')}}
                                </v-btn>
                            </v-col>
                            <v-divider vertical class="my-2" />
                            <v-col cols="auto">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ attr, on }">
                                        <v-btn
                                            dark
                                            color="alert-color"
                                            v-on="on"
                                            v-bind="attr"
                                        >
                                            <v-icon class="me-1">mdi-export-variant</v-icon>
                                            {{$t('exports.export')}}
                                        </v-btn>
                                    </template>
            
                                    <v-list nav dense>
                                        <v-list-item @click="getReport('pdf')">
                                            <v-list-item-icon class="me-4">
                                                <v-icon>mdi-printer</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                {{$t('exports.export-as-pdf')}}
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="getReport('excel')">
                                            <v-list-item-icon class="me-4">
                                                <v-icon>mdi-microsoft-excel</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                {{$t('exports.export-as-excel')}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!-- filter -->
        <bee-handy-table
			:headers="headers"
			:items="advanceStatement?.advanced_entries || []"
			ref="table"
			dense
			class="my-2 px-2 mx-2"
			:loading="loading"
			hide-inputs-details
			:data-table-props="{
                disableSort: true
			}"
            pagination-on-scroll
            zebra
            :height="$vuetify.breakpoint.height - 225"
            :items-per-page="-1"
            shown-rows-text=""
            fixed-header
            :context-menu-items="contextMenuItems"
            @contextmenu:row="(e, { item }) => contextMenuDeclarations(item)"
            @context-menu-show-related-journal="showRelatedJournal(relatedId)"
            @context-menu-show-related-invoice="showRelatedInvoice(relatedInvoice, relatedRouteName)"
            @dblclick:row="(e, { item }) => {
                contextMenuDeclarations(item),
                hadInvoiceId ? showRelatedInvoice(relatedInvoice, relatedRouteName) : showRelatedJournal(relatedId)
            }"
        >
            <template v-slot:item.material_id="{ item }">
                {{ !item.material_id ? item.note : materials.find(c => c.id === item.material_id)?.name }}
            </template>
            
            <template v-slot:item.options="{ item }">
                <div class="text-center">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attr }">
                            <v-btn
                                small
                                icon
                                v-bind="attr"
                                v-on="on"
                                width="32"
                                @click="contextMenuDeclarations(item)"
                            >
                                <v-icon>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="showRelatedJournal(relatedId)">
                                <v-list-item-content class="pa-0">
                                    {{ $t('menus.show-related-journal') }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="hadInvoiceId" @click="showRelatedInvoice(relatedInvoice, relatedRouteName)">
                                <v-list-item-content class="pa-0">
                                    {{ $t('menus.show-related-invoice') }}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </bee-handy-table>  

        <v-bottom-navigation
            id="footer"
            app
            class="px-3"
            horizontal
            background-color="#E1E2E4"
        >    
            <v-row align="center" justify="center" justify-lg="start">
                <v-col cols="auto" lg="auto" class="ma-0 pa-0 d-flex">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('AccountStatementPage.balance')"
                        :column="false"
                    >
                        <template  v-slot:content="{}">
                            <bee-advanced-money-label empty-state="_" v-model="sum_difference" :bold="true" :with-color="true"></bee-advanced-money-label>
                        </template>
                    </bee-outlined-header-info>
                </v-col>
                <v-spacer />
                <v-col cols="12" lg="6" class="d-flex justify-end align-center px-3">
                    <bee-outlined-header-info
                        border-color="transparent"
                        :head="$t('AccountStatementPage.sum-debit')"
                        :column="false"
                    ></bee-outlined-header-info>
                   
                    <bee-advanced-money-label empty-state="_" v-model="sum_debits" :bold="true" :with-color="true" ></bee-advanced-money-label>
                       
                    <bee-outlined-header-info
                        :column="false"
                        border-color="transparent"
                        :head="$t('AccountStatementPage.sum-credits')"
                    ></bee-outlined-header-info>
                 
                    <bee-advanced-money-label
                        empty-state="_"
                        v-model="sum_credits"
                        :bold="true"
                        :with-color="true"
                    ></bee-advanced-money-label>
                </v-col>      
            </v-row>
        </v-bottom-navigation>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import actions from "../../../permissions/actions-names.js"
import ls from "@/settings/localStorageExtension";
import { invoiceType } from '@/helpers/enums';

export default {
    data () {
        return {
            actions,
            tableInputs: {},
            entries: [],
            loading: false,
            accountId: null,
            fromDate: null,
            toDate: moment().format('YYYY-MM-DD'),
            showExchangeForm: false,
            keywords: null,
            
            relatedId: null,
            hadInvoiceId: false,
            invoiceType
        }
    },

    computed: {
        ...mapState({
            configs: state => state.configs.configs, 
            advanceStatement: state => state.statements.advanceStatement,
            materials: state => state.materials.materials,
            currentFinancialFile: state => state.financialFiles.current_financial_file,
        }),

        ...mapGetters({
            getMaterialById: 'materials/getMaterialById',
            getSettingByKey: 'settings/getSettingByKey',
            getAccountById: 'configs/getAccountById'
        }),
        showCounterAccount () {
            return this.getSettingByKey('showCounterAccount')?.setting_value;
        },
        headers () {
            const headers = [
                {
                    text:this.$t('headers.no'),
                    name: 'no',
                    value: 'no',
                    setValueExpr: (value, index) => index + 1
                },
                {
                    text: this.$t('headers.balance'),
                    name: 'balance',
                    value: 'balance',
                    setValueExpr: val => val.toLocaleString()
                },
                {
                    text: this.$t('headers.debit'),
                    name: 'debit',
                    value: 'debit.amount',
                    setValueExpr: val => val.toLocaleString()
                },
                {
                    text: this.$t('headers.credit'),
                    name: 'credit',
                    value: 'credit.amount',
                    setValueExpr: val => val.toLocaleString()
                },
                this.showCounterAccount 
				?{
					text: this.$t('AccountStatementPage.headers.peer-account'),
					value: 'counter_account_id',
					name: 'peerAccount',
					type: 'string',
					width: '10%',
					sortable: false,
                    setValueExpr: value => this.getAccountById(value)?.name || '-'
				} 
				: null,
                {
                    text: this.$t('headers.note'),
                    name: 'material_id',
                    value: 'material_id'
                },
                {
                    text: this.$t('headers.quantity'),
                    name: 'quantity',
                    value: 'quantity.quantity'
                },
                {
                    text: this.$t('headers.price'),
                    name: 'price',
                    value: 'price.amount'
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    noNotAvailableText: true,
                    setValueExpr: val => val !== null ? moment(val).format('YYYY-MM-DD') : '-'
                },
                {
                    text: '',
                    name: 'options',
                    value: 'options',
                    width: 34,
                    class: 'px-0',
                    cellClass: 'px-0'
                }
            ]
            return headers.filter(v => Boolean(v));
        },
        sum_difference(){ return this.accountId ? this.advanceStatement?.summary?.sum_result?.sum_difference : null || null },
 
        sum_debits() { return this.accountId ? this.advanceStatement?.summary?.sum_result?.sum_debits : null || null },

        sum_credits() { return this.accountId ? this.advanceStatement?.summary?.sum_result?.sum_credits : null || null },

        contextMenuItems() {
            const contextMenuItems = [
                {
                    title: this.$t('menus.show-related-journal'),
                    event: 'show-related-journal'
                }
            ];
            if(this.hadInvoiceId){
                contextMenuItems.push({
                    title: this.$t('menus.show-related-invoice'),
                    event: 'show-related-invoice',
                })
            }
            return contextMenuItems
        },
    },

    methods: {
        moment,
        getStatement () {
            this.loading = true
            this.$store.dispatch('statements/fetchStatementAdvance', {
                accountId: this.accountId,
                startDate: this.fromDate,
                endDate: this.toDate,
                keywords: this.keywords,
                includesPreviousBalance: true
            }).then(() => { 
            }).finally(() => {
                this.loading = false
            })
        },

        getReport(type) {
            this.$store.dispatch('reports/advanceStatement', {
                type,
                financialFileId: this.currentFinancialFile.id,
                userId: ls.getLocalUser().id,
                account_id: this.accountId,
                start_date: this.fromDate,
                end_date: this.toDate,
                includes_previous_balance: true
            }) 
        },

        showRelatedJournal(relatedId) {
            const route = this.$router.resolve({ 
                name: relatedId.isCash === true ? 'cash-journal' : 'accounting-journal', 
                params: { id: relatedId.bondId } 
            });
            window.open(route.href, '_blank');
        },
        showRelatedInvoice(relatedInvoice, relatedRouteName) {
            const routeName = 
                relatedRouteName === this.invoiceType.sale
                    ? 'invoices-sale'
                    : relatedRouteName === this.invoiceType.buy
                        ? 'invoices-buy'
                        : relatedRouteName === this.invoiceType.saleRefund
                            ? 'sale-invoice-refund'
                            : relatedRouteName === this.invoiceType.buyRefund
                                ? 'buy-invoice-refund'
                                : null

            const route = this.$router.resolve({ 
                name: routeName, 
                params: { id: relatedInvoice } ,
                query: { withCategory: true }
            });
            window.open(route.href, '_blank');
        },

        contextMenuDeclarations(item) {
            this.relatedId = {bondId: item.bond_id, isCash: item.is_cash};
            this.relatedInvoice = item.invoice_id || null;
            this.relatedRouteName = item.invoice_type;
            this.hadInvoiceId = Boolean(item.invoice_id)
        },
    },

    created() {
       this.$store.dispatch('materials/fetchAll')
       this.fromDate = this.configs.financial_file.start_date
       this.toDate = this.configs.last_entry_date;
    }
}
</script>
